import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { TokenProvider } from "./components/TokenContext";

import PrintDocumentSetting from "./components/PrintDocumentSetting"; // 성적표 화면 컴포넌트
import FetchReportPage from "./components/FetchReportPage"; // reportToken 처리 페이지
import ReportCardSetting from "./components/ReportCardSetting"; // reportToken 처리 페이지
import PageNotFound from "./components/PageNotFound"; // reportToken 처리 페이지


// JSON 데이터를 Post 방식으로 처리하기 위한 컴포넌트
const GeneralprintPage = () => {
    const location = useLocation();
    const [jsonData, setJsonData] = useState(null);

    useEffect(() => {
        // 평탄화된 JSON 데이터를 state에서 설정
        if (location.state) {
            setJsonData(location.state);
            // ('JSON 전체 데이터:', JSON.stringify(location.state, null, 2));
        }
    }, [location.state]);

    return (
        <div>
            {jsonData ? (
                <PrintDocumentSetting jsonData={jsonData} />
            ) : (
                <div>잘못된 접근입니다.</div>
            )}
        </div>
    );
};

// JSON 데이터를 Post 방식으로 처리하기 위한 컴포넌트
const ReportprintPage = () => {
    const location = useLocation();
    const [jsonData, setJsonData] = useState(null);

    useEffect(() => {
        // 평탄화된 JSON 데이터를 state에서 설정
        if (location.state) {
            setJsonData(location.state);
            // ('JSON 전체 데이터:', JSON.stringify(location.state, null, 2));
        }
    }, [location.state]);

    return (
        <div>
            {jsonData ? (
                <ReportCardSetting jsonData={jsonData} />
            ) : (
                <div>잘못된 접근입니다.</div>
            )}
        </div>
    );
};

const Root = () => {
    return (
        <TokenProvider>
            <Router>
                <Routes>
                    {/* 루트 경로에 App 연결 */}
                    <Route path="/" element={<FetchReportPage />} />
                    <Route path="/reportprint" element={<ReportprintPage />} />
                    <Route path="/generalprint" element={<GeneralprintPage />} />
                    {/* 404 처리 */}
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </Router>
        </TokenProvider>
    );
};

export default Root;
